/**
 * Follow an Ask run's event stream (GET /api/ask/runs/:id/stream — replays,
 * then live) and call `onEvent(type, data)` for each event, until the run
 * ends or `stop()` is called. How a dashboard page shows cards as Ask adds
 * them when the conversation is not on this page (TRO-469).
 */
function apiBase() {
  const explicit = (process.env.REACT_APP_API_SERVER_URL || '').trim();
  return explicit ? `${explicit}/api` : '/api';
}

export default function followRun(runId, team, onEvent) {
  const ctrl = new AbortController();
  const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
  const headers = { Accept: 'text/event-stream', 'X-Team-Id': String(team) };
  if (token) headers.Authorization = `Bearer ${token}`;

  (async () => {
    try {
      const res = await fetch(`${apiBase()}/ask/runs/${encodeURIComponent(runId)}/stream?team_id=${encodeURIComponent(team)}`, { headers, signal: ctrl.signal });
      if (!res.ok || !res.body) return;
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { value, done } = await reader.read();
        if (done) return;
        buffer += decoder.decode(value, { stream: true });
        let cut;
        while ((cut = buffer.indexOf('\n\n')) >= 0) {
          const block = buffer.slice(0, cut);
          buffer = buffer.slice(cut + 2);
          let type = 'message';
          const data = [];
          for (const line of block.split('\n')) {
            if (line.startsWith('event:')) type = line.slice(6).trim();
            else if (line.startsWith('data:')) data.push(line.slice(5).trim());
          }
          if (!data.length) continue;
          let payload = null;
          try { payload = JSON.parse(data.join('\n')); } catch (_) { payload = null; }
          onEvent(type, payload);
        }
      }
    } catch (_) {
      // aborted, or the connection dropped: the page still has what it loaded
    }
  })();

  return () => ctrl.abort();
}
